export const XR_MODULE_LIST = "/api/resource/module/list";
export const UNVERIFIED_RESOURCE = "/api/resource/unverified/list";
export const XR_MODULE_CREATE = "/api/resource/module/create";
export const XR_MODULE_DETAIL = "/api/resource/module/basic";
export const XR_MODULE_VIDEO = "/api/resource/module/video";
export const XR_MODULE_PUBLISH = "/api/resource/publish";
export const XR_ASSET_VERSION_LIST = "/api/resource/asset/list/versions";
export const XR_ALL_ASSET_VERSIONS = "/api/resource/asset/all/type/versions";
export const XR_ASSET_VERSION_CREATE = "/api/resource/asset/create/version";
export const XR_MODULE_TASK_SCENARIO = "/api/resource/module/tasks";
export const XR_MODULE_QR_LINK = "/api/resource/qr";
export const TAG_LIST = "/api/tag/list";
export const CREATE_TAG = "/api/tag/create";
export const PUBLISH_OPERATION_STATUS = "/api/sync/operation/status";
export const CHANNEL_LIST = "/api/channel/list";
export const LINKED_ASSET_LIST = "/api/resource/linked/list";
export const CONNECT_ASSETS = "/api/resource/linked";
export const CATEGORY_ASSETS_LIST = "/api/resource/3d/asset/list";
export const CREATE_TAG_CATEGORY = "/api/tag/category/create";
export const UPDATE_TAG_CATEGORY = "/api/tag/category/update";
export const DELATE_TAG_CATEGORY = "/api/tag/category/delete";
export const CATEGORY_CHILDREN_LIST = "/api/tag/category/list/resources";
export const RESOURCE_TYPE_APPLICATION = "/api/application/linked/resource/type";
export const FETCH_DYNAMIC_MODULES = "/api/resource/dynamic/module";
export const CREATE_DYNAMIC_MODULE = "/api/resource/dynamic/create/module";
export const UPDATE_DYNAMIC_MODULE = "/api/resource/dynamic/update/module";
export const SAVE_DYNAMIC_MODULE_STEPS = "/api/resource/dynamic/create/steps";
export const FETCH_DYNAMIC_INFO = "/api/resource/dynamic/info";
export const SAVE_ENVIRONMENT_DYNAMIC_INFO = "/api/resource/environment/dynamicinfo/save";
export const FETCH_AR_MODULE_LIST = "/api/resource/ar/list";
export const FETCH_AR_MODULE_DETAIL = "/api/resource/ar/details";
export const FETCH_AR_ASSET_FILE = "/api/resource/ar/asset/list";
export const CREATE_AR_MODULE = "/api/resource/ar/create";
export const UPDATE_AR_MODULE = "/api/resource/ar/update";
export const UPDATE_AR_MODULE_DETAIL = "/api/resource/ar/update/details";
export const FETCH_AR_ANCHOR_POINTERS = "/api/resource/ar/cloud/pointers/list";
export const UPDATE_AR_ANCHOR_POINTERS = "/api/resource/ar/update/cloud/pointer/details";
export const SAVE_HOTSPOT_DATA = "/api/resource/ar/save/hotspots";
export const SAVE_AR_3D_ASSET = "/api/resource/ar/asset/upload";
export const CREATE_AR_ASSET_MODULE = "/api/resource/ar/asset/save";
export const FETCH_AR_MODULE_ASSETS = "/api/resource/ar/asset/list";
export const DELETE_2D_LMS_MODULE = "/api/resource/2d/lms/delete";
export const SAVE_OR_FETCH_2D_ASSIGNMENT = "/api/resource/2d/lms/asset/assignment/version";
export const CREATE_BULK_MODULE_BY_CSV = "/api/bulk-actions/modules/create";
